import {Breadcrumbs, Link, Typography} from "@material-ui/core";
import {ArrowBack} from "@material-ui/icons";
import React from "react";

const FormTabsNavigation = ({ history, active, userMadeChanges, setUserMadeChanges, setClickOnArrowBack, hasError }) => {

    const elements = [...history];
    const first = elements.shift();

    const handleGoBack = (element) => {
        setClickOnArrowBack(true, () => {
            if (userMadeChanges) {
                const message = hasError
                    ? 'There are required fields that need to be filled in. Are you sure you want to leave?'
                    : 'You have unsaved changes, are you sure you want to leave?';
                if (window.confirm(message)) {
                    setUserMadeChanges(false);
                    element.onClick();
                } else {
                    setClickOnArrowBack(false);
                }
            } else {
                element.onClick();
            }
        });
    }

    return (
        <>
            <Breadcrumbs className="form-tabs-breadcrumb" aria-label="breadcrumb">

                <Link className="breadcrumb-item" underline="hover" color="primary" onClick={()=> handleGoBack(first)} key={first?.name}>
                    <ArrowBack />
                    { first?.name }
                </Link>
                { elements.map((h) => (
                    <Link underline="hover" color="primary" onClick={()=> handleGoBack(h)} key={h?.name}>
                        { h?.name }
                    </Link>
                ))
                }
                <Typography className="breadcrumb-item"  color="inherit">{active.name}</Typography>
            </Breadcrumbs>
        </>
    )
}
export default FormTabsNavigation;